import React from "react";
import { Modal } from "react-bootstrap";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Radio from "@material-ui/core/Radio";
import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage } from "formik";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import applestore from "../Home/banner/assets/images/applestore.png";

import playstore from "../Home/banner/assets/images/playstore.png";
export default function Connect({ status = false, setchoosebox, expertData }) {
  console.log("EXPERT DATA", expertData);
  return (
    <>
      <MyVerticallyCenteredModal
        show={status}
        expertData={expertData}
        onHide={() => setchoosebox(false)}
      />
    </>
  );
}

const SignupSchema = Yup.object().shape({
  full_name: Yup.string()
    .min(3, "Name must be 3 characters at minimum")
    .required("Name is required"),

  email: Yup.string()
    .email("Invalid email address format")
    .required("Email is required"),

  phoneNumber: Yup.string()
    .min(9, "Phone Number Invalid")
    .required("Phone Number is required"),
});

function MyVerticallyCenteredModal(props) {
  const [formValues, setFormValues] = React.useState({
    request: "",
    video: "",
    treatment: "",
    insurance: "",
    constraint: "",
    contacted: "",
  });
  const [error, setErrors] = React.useState({
    request: "",
    video: "",
    treatment: "",
    insurance: "",
    constraint: "",
    contacted: "",
  });
  const [pending, setPending] = React.useState(false);
  const [message, setMessage] = React.useState("");

  const handleChange = (event) => {
    setFormValues({ ...formValues, [event.target.name]: event.target.value });
  };

  const onSubmitForm = async (data) => {
    setErrors({});
    let errorObj = {};
    if (!formValues.request)
      errorObj.request = "You must choose atleast 1 option";
    if (!formValues.treatment)
      errorObj.treatment = "You must choose atleast 1 option";
    if (!formValues.video) errorObj.video = "You must choose atleast 1 option";
    if (!formValues.constraint)
      errorObj.constraint = "You must choose atleast 1 option";
    if (!formValues.contacted)
      errorObj.contacted = "You must choose atleast 1 option";
    if (!formValues.insurance)
      errorObj.insurance = "You must choose atleast 1 option";
    setErrors(errorObj);
    if (Object.keys(errorObj).length > 0 && errorObj.constructor === Object)
      return;

    const message = `Name: ${data.full_name}
     \n Email: ${data.email} 
     \n Phone Number: ${data.phoneNumber} 
      `;
    try {
      // Sending Email
      setPending(true);
      const result = await axios.post(
        "https://shrouded-crag-83577.herokuapp.com/contact",
        {
          to: "navigators@medanswers.com",
          message,
        }
      );

      if (result && result.data && result.data.success) {
        setPending(false);
        const name = toast.success(
          // "Message Succesfully Sent to " + props.expertData.first_name
          //   ? props.expertData.first_name
          //   : props.expertData.name + " " + props.expertData.last_name
          //   ? props.expertData.last_name
          //   : ""
          "Message Successfully Sent"
        );
      }
    } catch (e) {
      console.log(e.message);
      setPending(false);
      props.onHide();
    }
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={{
            full_name: "",
            email: "",
            phoneNumber: "",
          }}
          validationSchema={SignupSchema}
          onSubmit={(data) => {
            onSubmitForm(data);
          }}
        >
          {({ touched, errors }) => (
            <Form>
              <ToastContainer closeButton={false} />;
              <div className="connect">
                <div clasNAme="content">
                  <div className="description">
                    <h2>
                      Connect with{" "}
                      {props.expertData.first_name &&
                        `${props.expertData.first_name} `}
                      {props.expertData.last_name &&
                        `${props.expertData.last_name} `}
                      {props.expertData.name && `${props.expertData.name} `}
                    </h2>
                    <p>
                      Once you complete this brief contact form, our partner
                      will be in touch to schedule you for a 15 minute
                      consultation.{" "}
                    </p>
                  </div>
                  <div className="form-first form-group">
                    <label> Name</label>
                    <Field
                      type="text"
                      name="full_name"
                      placeholder="Full Name"
                      className={`form-control ${
                        touched.full_name && errors.full_name
                          ? "is-invalid"
                          : ""
                      }`}
                    />
                    <ErrorMessage
                      component="div"
                      name="full_name"
                      className="invalid-feedback"
                      style={{
                        marginTop: "0",
                        marginBottom: "0",
                      }}
                    />

                    <label> Email</label>
                    <Field
                      type="text"
                      name="email"
                      placeholder="Email"
                      className={`form-control ${
                        touched.email && errors.email ? "is-invalid" : ""
                      }`}
                    />
                    <ErrorMessage
                      component="div"
                      name="email"
                      className="invalid-feedback"
                      style={{ marginTop: "0", marginBottom: "0" }}
                    />

                    <label> Phone Number</label>
                    <Field
                      type="text"
                      name="phoneNumber"
                      placeholder="Enter your Phone Number"
                      className={`form-control ${
                        touched.phoneNumber && errors.phoneNumber
                          ? "is-invalid"
                          : ""
                      }`}
                    />
                    <ErrorMessage
                      component="div"
                      name="phoneNumber"
                      className="invalid-feedback"
                      style={{ marginTop: "0", marginBottom: "0" }}
                    />
                  </div>
                  <div className="checkbox-section">
                    <h4>
                      Please indicate what kind of appointment request this is:
                    </h4>
                    <FormControl component="fieldset">
                      <RadioGroup
                        aria-label="request"
                        name="request"
                        onChange={handleChange}
                      >
                        <FormControlLabel
                          value="First Consult "
                          control={<Radio />}
                          label="First Consult "
                        />
                        <FormControlLabel
                          value="Second Opinion Consult "
                          control={<Radio />}
                          label="Second Opinion Consult "
                        />
                        <FormControlLabel
                          value="I’m not ready for a consult, please just send me an information kit "
                          control={<Radio />}
                          label="I’m not ready for a consult, please just send me an information kit "
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                  {error.request && (
                    <div className="error-custom-partners">{error.request}</div>
                  )}

                  <div className="checkbox-section">
                    <h4>
                      Are you comfortable with having a video consult as the
                      first appointment?
                    </h4>
                    <FormControl component="fieldset">
                      <RadioGroup
                        aria-label="video"
                        name="video"
                        onChange={handleChange}
                      >
                        <FormControlLabel
                          value="yes"
                          control={<Radio />}
                          label="yes"
                        />
                        <FormControlLabel
                          value="no"
                          control={<Radio />}
                          label="no"
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                  {error.video && (
                    <div className="error-custom-partners">{error.video}</div>
                  )}
                  <div className="checkbox-section">
                    <h4>Have you had fertility treatment done before?</h4>
                    <FormControl component="fieldset">
                      <RadioGroup
                        aria-label=" treatment"
                        name="treatment"
                        onChange={handleChange}
                      >
                        <FormControlLabel
                          value="yes"
                          control={<Radio />}
                          label="yes"
                        />
                        <FormControlLabel
                          value="no"
                          control={<Radio />}
                          label="no"
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                  {error.treatment && (
                    <div className="error-custom-partners">
                      {error.treatment}
                    </div>
                  )}
                  <div className="checkbox-section">
                    <h4>Does your insurance have fertility benefits?</h4>
                    <FormControl component="fieldset">
                      <RadioGroup
                        aria-label="insurance"
                        name="insurance"
                        onChange={handleChange}
                      >
                        <FormControlLabel
                          value="yes"
                          control={<Radio />}
                          label="yes"
                        />
                        <FormControlLabel
                          value="no"
                          control={<Radio />}
                          label="no"
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                  {error.insurance && (
                    <div className="error-custom-partners">
                      {error.insurance}
                    </div>
                  )}
                  <div className="checkbox-section">
                    <h4>
                      How much of a financial constraint would proceeding with
                      treatment pose to you?
                    </h4>
                    <FormControl component="fieldset">
                      <RadioGroup
                        aria-label="constraint"
                        name="constraint"
                        onChange={handleChange}
                      >
                        <FormControlLabel
                          value="Not much at all "
                          control={<Radio />}
                          label="Not much at all "
                        />
                        <FormControlLabel
                          value="It’s within my budget "
                          control={<Radio />}
                          label="It’s within my budget "
                        />
                        <FormControlLabel
                          value="This would be a significant financial constraint  "
                          control={<Radio />}
                          label="This would be a significant financial constraint "
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                  {error.constraint && (
                    <div className="error-custom-partners">
                      {error.constraint}
                    </div>
                  )}
                  <div className="checkbox-section">
                    <h4>How would you like to be contacted?</h4>
                    <FormControl component="fieldset">
                      <RadioGroup
                        aria-label="contacted"
                        name="contacted"
                        onChange={handleChange}
                      >
                        <FormControlLabel
                          value="Email"
                          control={<Radio />}
                          label="Email"
                        />
                        <FormControlLabel
                          value="call"
                          control={<Radio />}
                          label="call"
                        />
                        <FormControlLabel
                          value="Text"
                          control={<Radio />}
                          label="Text"
                        />
                      </RadioGroup>
                    </FormControl>
                    {error.contacted && (
                      <div className="error-custom-partners">
                        {error.contacted}
                      </div>
                    )}

                    {/* {message && <p>{message}</p>} */}
                    <button className="submit" type="submit">
                      {pending ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
      <Modal.Footer>
        <div className="footer_connect">
          <h5>Download Fertility Answers Mobile App</h5>
          <div className="socialimages-footer">
            <a
              target="_blank"
              href="https://apps.apple.com/us/app/fertilityanswers/id1418650176"
            >
              <img src={applestore} />
            </a>
            <a
              target="_blank"
              href="https://play.google.com/store/apps/details?id=com.fertilityanswers"
            >
              <img src={playstore} />
            </a>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
